export default "__VITE_ASSET__XNhP84hk__"